import React from 'react';
import {observer} from "mobx-react-lite";
import {useServices} from "../../../../../../react-hooks/use-services.hook";
import {LicenseTextLinkBox} from "../../boxes/regulatory/license-status/license-text-link.box";

export const VideoSlidesLicensePopupContentComponent: React.FC = observer(() => {
    const services = useServices();

    /** Takes the str string and replaces the first occurrence of substr with the first React Element in the reactElements array,
        the second occurrence of substr with the second React Element in the reactElements array and so on
        This kind of logic is needed when we have a large text (which needs to be translated) which also needs to contain links and stylized pieces of text.
     **/

    const replaceWithReactElement = (str: string, substr: string, reactElements: React.ReactElement[]): (string | React.ReactElement)[] => {

        if (reactElements.length === 0) {
            return [str];
        }

        const parts = str.split(substr);
        let elArrIndex = 0;

        return parts.reduce((acc, part, index) => {
            acc.push(part);

            if (index < parts.length - 1) {
                acc.push(React.cloneElement(reactElements[elArrIndex], { key: index }));
                if (elArrIndex < reactElements.length - 1) {
                    elArrIndex++;
                }
            }

            return acc;
        }, []);
    }

    return (
        <>
            {
                replaceWithReactElement(
                    services.translation.translate("UK_LICENSE_TEXT"),
                    "#UK-LICENSE-PAGE-LINK#",
                    [
                        <LicenseTextLinkBox onClick={() => services.linksNavigation.openGamblingCommissionLink()}>
                            {services.translation.translate('UK_LICENSE_GC_PAGE_LINK')}
                        </LicenseTextLinkBox>,
                        <LicenseTextLinkBox onClick={() => services.linksNavigation.openResponsibleGaming()}>
                            {services.translation.translate('UK_LICENSE_RG_PAGE_LINK')}
                        </LicenseTextLinkBox>
                    ]
                )
            }
        </>
    );
})